import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import EmploymentLengthViewModel from '../ViewModels/EmploymentLengthViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IEmploymentLengthDropDownProps {
    setEmploymentLength?: (event) => void;
    employmentLength: string | undefined;
    disabled: boolean;
    label: string;
    unemploymentMode: boolean;
}

interface IEmploymentLengthDropDownState {
    model: EmploymentLengthViewModel[];
    loaded: boolean;
}

class EmploymentLengthDropDown extends Component<IEmploymentLengthDropDownProps & WithStyles<typeof styles>, IEmploymentLengthDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            if (this.props.unemploymentMode) {
                fetch('api/DropDown/GetUnemploymentLengths').then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
            } else {
                fetch('api/DropDown/GetEmploymentLengths').then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
            }
        }
    }

    componentDidMount() {
        if (this.props.unemploymentMode) {
            fetch('api/DropDown/GetUnemploymentLengths').then(response => response.json()).then((data) => {
                this.setState({
                    model: data,
                    loaded: true,
                });
            });
        } else {
            fetch('api/DropDown/GetEmploymentLengths').then(response => response.json()).then((data) => {
                this.setState({
                    model: data,
                    loaded: true,
                });
            });
        }
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultEmploymentLengthVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.label}
                name={this.props.unemploymentMode ? "unemploymentLength" : "employmentLength"}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.employmentLength}
                onChange={this.props.disabled ? undefined : this.props.setEmploymentLength}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(EmploymentLengthDropDown);